/* -----------------------------------------
Import
----------------------------------------- */

import initSliderHeader from 'scripts/marmalade/elements/slider-header';

/* -----------------------------------------
Document setup
----------------------------------------- */

[...document.querySelectorAll('.js-gallery-link')].forEach(block => {
  // Get the slider container
  const container = block.querySelector('.js-gallery-link__slider');
  // The number of columns
  const columns = container.getAttribute('data-columns');

  // Create an observer to add the in-view class to the slide when the slide is visible
  const Observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.classList.toggle('in-view', entry.isIntersecting);
    });
  }, {
    threshold: 1,
    rootMargin: '100% 0px 100% 0px'
  });

  // Create the slider
  block.tns = tns({
    container,
    items: 1,
    controls: true,
    nav: true,
    navPosition: 'bottom',
    mouseDrag: true,
    loop: true,
    gutter: 40,
    mobileFirst: true,
    responsive: {
      1360: {
        items: columns
      }
    }
  });
  initSliderHeader(block, block.tns);

  // Get the slider data and observer the slides
  [...block.tns.getInfo().slideItems].forEach(slide => Observer.observe(slide));
});